import { deleteEntry, getContentType, getEntries, createEntry, getEntry, updateEntry} from '../api/api';

export const UPDATE_STEP_DATA = 'UPDATE_STEP_DATA';
export const RESET_FORM = 'RESET_FORM';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const ADD_FIELD = 'ADD_FIELD';

export const addField = (fieldData) => ({
  type : ADD_FIELD,
  payload:fieldData,
});
export const UPDATE_CONTENT_TYPE = 'UPDATE_CONTENT_TYPE';

export const updateField = (index,fieldData ) => ({
  type : UPDATE_FIELD,
  payload : { index, fieldData }
});

export const updateContentType = (contentTypeData) => ({
  type: UPDATE_CONTENT_TYPE,
  payload: contentTypeData,
});

export const resetForm = () => ({
  type: RESET_FORM,
});


export const getAllEntries = (workspaceId) => async (dispatch) => {
  try {
    const res = await getEntries(workspaceId);
    dispatch({
      type:'GET_ALL_ENTRIES',
      payload:res.data
    });

  } catch (err){
    console.log(err)
  }
}


export const getContentTypeForEntry = (workspaceId, id) => async (dispatch) => {
  try {
    const res = await getContentType(workspaceId, id);
    dispatch({
      type:'GET_CONTENT_TYPE_FOR_ENTRY',
      payload:res.data
    });

  } catch (err){
    console.log(err)
  }
}



export const submitFormData = (entryData) => async(dispatch)=> {
  try {
    dispatch({ 
      type: 'FORM_SUBMISSION_REQUEST' 
    });
    const res = await createEntry(entryData);
    dispatch({ 
      type: 'FORM_SUBMISSION_SUCCESS', 
      payload: res.data 
    });
    return res.data;

  } catch (error){
    dispatch({ 
      type: 'FORM_SUBMISSION_FAILURE', 
      payload: error.message 
    });
  }

}

export const getEntryForEdit = (workspaceId, id) => async (dispatch) => {
  try {
    const res = await getEntry(workspaceId, id);
    dispatch({
      type:'GET_SINGLE_ENTRY',
      payload:res.data
    });

  } catch (err){
    console.log(err)
  }
}

export const getEntryForDrawer = (workspaceId, entryId) => async (dispatch) => {
  try {
    const res = await getEntry(workspaceId, entryId);
    
    dispatch({
      type: 'GET_ENTRY_FOR_DRAWER',
      payload: res.data
    });
    
  } catch (error) {
    console.error('Error fetching drawer entry:', error);
  }
};

export const updateEntryData = (id, data) => async(dispatch)=> {
  try {
    const res = await updateEntry(id, data);
    return res.data;
  } catch (error){

    console.error('Failed to submit form:', error);
  }
}


export const removeEntry = (id) => async (dispatch) => {
  try {
    const res = await deleteEntry(id);
    if (res.status === 200){
      dispatch({
        type:'DELETE_ENTRY',
        payload:id
      })
    }

  } catch (err){
    console.log(err)
  }
}
